<template>
  <header class="header">
    <app-logo />
    <router-link :to="{ name: 'dashboard' }">
      <h2 class="header-title">Race Analytics</h2>
    </router-link>
    <slot />
    <div class="header-right">
      <ml-engine />
      <slot v-if="$slots.right" name="right" />
      <v-btn
        color="var(--v-grey-darken-1)"
        icon
        small
        @click="logoutClickHandler"
      >
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </div>
  </header>
</template>

<script>
import AppLogo from './AppLogo'
import {mapActions} from 'vuex'
import MlEngine from '@/components/MlEngine'

export default {
  name: 'AppHeader',
  components: {
    AppLogo,
    MlEngine,
  },
  methods: {
    ...mapActions({
      logout: 'logout'
    }),
    logoutClickHandler() {
      this.logout()
    },
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 20px 0 24px;
  border-bottom: 1px solid var(--v-blue-lighten-1);
}

.header-title {
  padding: 0 16px;
  color: var(--v-secondary-base);
  font-size: 14px;
  font-weight: 700;
}

.header-right {
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 24px;
}
</style>
